module.exports = __webpack_public_path__ + "static/media/consultation.7dc8cd2a.svg";